module.exports = __webpack_public_path__ + "img/customer-count.f1fbc215.svg";